// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

//  引入Element-UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueCookies from "vue-cookies";
import store from './store/index';
import {checkHasLogin} from "./api/util";
import Directive from './directive/directive'
import VueGtag from "vue-gtag";

ElementUI.Dialog.props.lockScroll.default = false;

Vue.prototype.$store = store;
axios.defaults.withCredentials = true
Vue.use(VueCookies);
Vue.use(ElementUI)
Vue.use(Directive)
Vue.config.productionTip = false

import VueI18n from 'vue-i18n';
import enLocale from './lang/en.json';
import zhLocale from './lang/zh.json';

Vue.use(VueI18n);
Vue.use(VueGtag, {
  config: { id: "G-8E5ZE4RN99" }
},router);

const messages = {
  en: enLocale,
  zh: zhLocale
};

// 语言选择的方法
const setLanguage = () => {
  const storedLanguage = localStorage.getItem('selectedLanguage');
  if (storedLanguage) {
    // 如果localStorage中有存储的语言选择，则使用存储的选择
    return storedLanguage;
  } else {
    // 如果localStorage中没有存储的语言选择，则默认为中文（'zh'）
    localStorage.setItem('selectedLanguage', 'zh');
    return 'zh';
  }
};
const setCurrency = () => {
  const storedCurrency = localStorage.getItem('selectedCurrency');
  if (storedCurrency) {
    // 如果localStorage中有存储的货币选择，则使用存储的货币选择
    return storedCurrency;
  } else {
    // 如果localStorage中没有存储的货币选择，则默认为CNY
    localStorage.setItem('selectedCurrency', 'CNY');
    return 'CNY';
  }
}

// 使用方法来获取当前语言选择
const selectedLanguage = setLanguage();
const selectedCurrency = setCurrency();

// 通过选项创建 VueI18n 实例
const i18n = new VueI18n({
  locale: setLanguage(), // 设置地区
  messages, // 设置地区信息
})


// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 获取用户信息，可以从LocalStorage、Cookie或服务器端获取
  checkHasLogin().then(hasLogin => {
    if (hasLogin) {
      // 用户已登录，可以继续访问
      // 也可以将用户信息保存在Vuex中，以便在组件中使用
      next();
    } else {
      if (to.meta.needLogin == undefined || to.meta.needLogin == false) {
        next();
      } else {
        if (hasLogin) {
          next();
        } else {
          // 用户未登录，重定向到登录页面 去掉refreshToken
          ElementUI.Message.error('Login Required');
          next({name: 'Home'});
        }
      }
    }
  });
});

/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  created() {
    let currency = localStorage.getItem("selectedCurrency")
    store.commit('setCurrency', currency !== null ? currency : 'CNY');
  },
  template: '<App/>',
  i18n
})

export default vm



// WEBPACK FOOTER //
// ./src/main.js